import { PlanDetail } from '@link/share/booking';
import { useBookingStore } from '../context';

/**
 * Every plan's details, in the server HTML but not on screen.
 *
 * Visitors read them in the details drawer, which opens on a click and so
 * renders only in the browser. Rendering the same component here, hidden,
 * puts the text in the page crawlers index.
 */
export function PlanDetailsForCrawlers() {
  const store = useBookingStore();
  return (
    <div hidden>
      {store.plans.map(plan => (
        <PlanDetail key={plan.id} plan={plan} />
      ))}
    </div>
  );
}
